import Autocomplete from 'js-autocomplete';

function initializeCardAutocomplete() {
  $('.card-autocomplete').each(function () {
    var input = this;
    var fetchedData = [];

    if (input) {
      // Clear hidden ID field when user types manually
      $(input).on('input', function() {
        var inputId = $(this).attr('id');
        var hiddenFieldId = inputId.replace('_card_no', '_id');
        var hiddenIdField = $('#' + hiddenFieldId);
        
        // Only clear if the current value doesn't match any fetched card
        var currentValue = $(this).val();
        var matchedCard = fetchedData.find(card => card.card_no === currentValue);
        if (!matchedCard && hiddenIdField.length) {
          hiddenIdField.val('');
        }
      });
      
      // Add keyboard navigation support
      $(input).on('keydown', function(e) {
        var suggestions = $('.autocomplete-suggestions .autocomplete-suggestion');
        var selected = $('.autocomplete-suggestions .autocomplete-selected');
        
        if (e.keyCode === 40) { // Down arrow
          e.preventDefault();
          if (selected.length === 0) {
            suggestions.first().addClass('autocomplete-selected');
          } else {
            selected.removeClass('autocomplete-selected');
            var next = selected.next('.autocomplete-suggestion');
            if (next.length > 0) {
              next.addClass('autocomplete-selected');
            } else {
              suggestions.first().addClass('autocomplete-selected');
            }
          }
        } else if (e.keyCode === 38) { // Up arrow
          e.preventDefault();
          if (selected.length === 0) {
            suggestions.last().addClass('autocomplete-selected');
          } else {
            selected.removeClass('autocomplete-selected');
            var prev = selected.prev('.autocomplete-suggestion');
            if (prev.length > 0) {
              prev.addClass('autocomplete-selected');
            } else {
              suggestions.last().addClass('autocomplete-selected');
            }
          }
        } else if (e.keyCode === 13) { // Enter
          e.preventDefault();
          if (selected.length > 0) {
            selected.click();
          }
        }
      });

      new Autocomplete({
        selector: input,
        minChars: 4,
        delay: 300,
        cache: false,
        source: function (term, suggest) {
          var companyId = $('#current_company_id').val();
          var availableOnly = $(input).data('available-only') || '';

          // Show searching state immediately
          suggest(['Searching...']);

          fetch(`/cards/filter?card_no=${term}&company_id=${companyId}&available_only=${availableOnly}`)
            .then(response => response.json())
            .then(data => {
              fetchedData = data;
              if (data.length === 0) {
                suggest(['No card found']);
              } else {
                suggest(data.map(card => card.card_no));
              }
            })
            .catch(error => {
              console.error('Error fetching data:', error);
              suggest(['Search failed']);
            });
        },
        renderItem: function (item, search) {
          if (item === 'Searching...' || item === 'No card found' || item === 'Search failed') {
            return (
              '<div class="autocomplete-suggestion" data-val="" data-id="">' +
              '<em style="color: #999;">' + item + '</em>' +
              '</div>'
            );
          }
          var matchedCard = fetchedData.find(card => card.card_no === item);
          var cardId = matchedCard ? matchedCard.id : '';
          return (
            '<div class="autocomplete-suggestion" data-val="' +
            item +
            '" data-id="' +
            cardId +
            '">' +
            item +
            '</div>'
          );
        },
        onSelect: function (event, term, item) {
          var inputId = $(input).attr('id');
          var hiddenFieldId = inputId.replace('_card_no', '_id');
          var hiddenIdField = $('#' + hiddenFieldId);
          var cardId = $(item).attr('data-id');

          if (hiddenIdField.length && cardId && cardId !== '') {
            hiddenIdField.val(cardId);
          } else if (hiddenIdField.length) {
            hiddenIdField.val('');
          }
        },
        menuClass: 'autocomplete-suggestions',
        selectedClass: 'autocomplete-selected',
        suggestionClass: 'autocomplete-suggestion'
      });
    }
  });
}

$(document).ready(initializeCardAutocomplete);
document.addEventListener('turbolinks:load', initializeCardAutocomplete);
document.addEventListener('turbo:load', initializeCardAutocomplete);
